// extracted by mini-css-extract-plugin
export var closeButton = "_bu-1";
export var closeX = "_bu-3";
export var container = "_bu-0";
export var image = "_bu-2";